module.exports = __webpack_public_path__ + "img/monterey-g-series-rectangle-side-angle.5a78458a.png";